//const defaultTheme = require('tailwindcss/defaultTheme');

module.exports = {
  mode: 'jit',
  content: ['./src/**/*{html,.js}'],
  important: 'body #appRoot',
  theme: {
    container: {
      center: true,
      padding: {
        DEFAULT: '1.5rem',
        sm: '1.5rem',
        md: '1.75rem',
        lg: '2rem',
        xl: '3rem'
      }
    },
    fontFamily: {
      sans: ['Helvetica Neue', 'sans-serif']
    },
    fontSize: {
      '2xs': ['9px', '11px'],
      xs: ['11px', '14px'],
      sm: ['12px', '14px'],
      base: ['14px', '14px'],
      md: ['16px', '19px'],
      lg: ['18px', '19px'],
      xl: ['20px', '25px'],
      '2xl': ['24px', '29px'],
      arrow: ['36px', '41px']
    },
    fontWeight: {
      base: '400',
      semibold: '600',
      bold: '700'
    },
    borderWidth: {
      DEFAULT: '1px',
      0: '0',
      1.5: '1.5px',
      2: '2px',
      3: '3px',
      4: '4px',
      6: '6px',
      8: '8px'
    },
    extend: {
      transitionDuration: {
        400: '400ms'
      },
      colors: {
        product: '#E6E6E6',
        heroarrows: '#777777'
      },
      animation: {
        fade: 'fadeIn .2s ease-in-out'
      },
      keyframes: (theme) => ({
        fadeIn: {
          from: { opacity: 0 },
          to: { opacity: 1 }
        }
      })
    }
  },
  plugins: [require('@tailwindcss/aspect-ratio')]
};
